module.exports = __webpack_public_path__ + "static/media/cbg6.f04cc7a6.png";